import Vue from 'vue'
import wx from 'weixin-js-sdk'
import VueJsonp from 'vue-jsonp'
import App from './App.vue'
import router from './router'
import moment from "moment"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import IconSvg from './components/IconSvg'
import './plugins/vant'
import './plugins/flexible'
import filters from './plugins/filters'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
//自定义组件名
Vue.component('IconSvg', IconSvg)
// 引入css
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import utils from './utils/utils'

import service from './service'
import auth from './utils/auth'
import methodPlu from './components/mixMethods'
import store from './store'
import payMethods from '../src/components/payMethods'

Vue.config.productionTip = false
Vue.prototype.$service = service
Vue.prototype.$moment = moment
Vue.prototype.$wx = wx
Vue.prototype.$env=process.env.VUE_APP_PREFIX;

localStorage.setItem("burryAppname","O2Owechatapp")

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.use(auth,router)
Vue.use(methodPlu)
Vue.use(VueJsonp)
Vue.use(payMethods)



window.openApp = function(pf){
  Vue.prototype.$platform = pf;
  let sessionId = generateGuid();
  localStorage.setItem("burrySessionId",sessionId)
}

let indexRoute = utils.getIndexRoute()
Vue.prototype.$indexRoute = indexRoute;
Vue.prototype.$routeLength = 0

let oid = utils.getQueryVariable('oid') || ""
if(oid){
  localStorage.setItem("oid",oid)
}

window.onload = function () {
  let domloadTime = window.performance.timing.domContentLoadedEventEnd- window.performance.timing.navigationStart;
  setTimeout(()=>{
    Vue.prototype.$service.getStatisCommon("evn_app_finish",{
      "entry":1,
      ltime: domloadTime
    });
    let loadTime = window.performance.timing.loadEventEnd - window.performance.timing.navigationStart; 
    
    let ed = {}
    if(indexRoute === "detail"){
      ed.saleSkuId = utils.getQueryVariable('saleSkuId') || utils.getQueryVariable('goodsId') || "";
      ed.categoryId = '';
    }
    if(indexRoute === "orderDetail"){
      ed.orderId = utils.getQueryVariable('orderId') || ""
    }
    Vue.prototype.$service.getStatisCommon("evn_open_app",{
      "entry":1,
      ed:ed,
      ltime: loadTime
    });
  },500)
}

Vue.config.errorHandler = function (err, vm, info) {
  let message = "exception:"+err+";info:"+info;
  service.getStatisCommon('evn_error_page',{ed:message})
}

// wx.miniProgram.getEnv(function(res) { console.log(res) })


function generateGuid(){
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  const PRE = 's_';
  return PRE + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}


new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
